import React from "react";

const CarHorasSociales = ({ datos }) => {
  const { empresa, actividad, tipo_hora_social, fecha_inicio, fecha_fin, horas } = datos;
  let desde = new Date(fecha_inicio);
  let hasta = new Date(fecha_fin);
  return (
    <tr>
      <td><b>{empresa}</b></td>
      <td>{actividad}</td>
      <td>{tipo_hora_social}</td>
      <td>{desde.toLocaleString().substr(0, 10)}</td>
      <td>{hasta.toLocaleString().substr(0, 10)}</td>
      <td>
        <span className="esen-chip esen-chip--success">
          <i className="fa fa-clock-o" aria-hidden="true"></i>
          {horas}
        </span>
      </td>
    </tr>
  );
};

export default CarHorasSociales;
